import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import CheckBoxLabelHookForm from "../../../../../components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";

import { IEmpTitleDetails } from "../types";

interface Props {
  rowForEdit: IEmpTitleDetails | undefined;
  setChanges: Dispatch<SetStateAction<boolean>>;
}
export const EmployeeTitleDetails: React.FC<Props> = ({ rowForEdit, setChanges }) => {
  const { register, watch } = useFormContext();
  const formMethods = useFormContext();

  const [checkBoxChanges, setCheckBoxChanges] = useState(rowForEdit?.isActive);
  const [isMexicoChange, setIsMexicoChange] = useState(rowForEdit?.usedInMexico);

  return (
    <>
      <div className="bg-bgDB pb-1 px-2">
        <div className="bg-white box-shadow rounded-lg h-full">
          <div className="grid grid-cols-4 mx-3 gap-x-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="employeeTitleName"
                label="Employee Title Name"
                type="text"
                onChange={(e) => {
                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value.trim() === rowForEdit?.employeeTitleName &&
                      formMethods.getValues("jobLong").trim() === rowForEdit?.jobLong?.trim() &&
                      formMethods.getValues("jobCode").trim() === rowForEdit?.jobCode?.trim() &&
                      checkBoxChanges === rowForEdit?.isActive &&
                      (isMexicoChange === true) === (rowForEdit?.usedInMexico === true))
                  ) {
                    setChanges(true);
                  } else {
                    setChanges(false);
                  }

                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.employeeTitleName &&
                  formMethods.formState.errors.employeeTitleName.message &&
                  "border-2 border-red-500 col-span-2"
                }
                register={formMethods.register("employeeTitleName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="jobLong"
                label="Job Long"
                type="text"
                onChange={(e) => {
                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value.trim() === rowForEdit?.jobLong &&
                      formMethods.getValues("employeeTitleName").trim() === rowForEdit?.employeeTitleName?.trim() &&
                      formMethods.getValues("jobCode").trim() === rowForEdit?.jobCode?.trim() &&
                      checkBoxChanges === rowForEdit?.isActive &&
                      (isMexicoChange === true) === (rowForEdit?.usedInMexico === true))
                  ) {
                    setChanges(true);
                  } else {
                    setChanges(false);
                  }

                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.jobLong &&
                  formMethods.formState.errors.jobLong.message &&
                  "border-2 border-red-500 col-span-2"
                }
                register={formMethods.register("jobLong", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
          </div>

          <div className="grid grid-cols-8 mx-3 gap-x-6 py-2">
            <div className="col-span-4 my-1">
              <TextInputLabelHookForm
                name="jobCode"
                label="Job Code"
                type="text"
                onChange={(e) => {
                  if (
                    e.target.value.trim() === "" ||
                    (e.target.value.trim() === rowForEdit?.jobCode &&
                      formMethods.getValues("employeeTitleName").trim() === rowForEdit?.employeeTitleName?.trim() &&
                      formMethods.getValues("jobLong").trim() === rowForEdit?.jobLong?.trim() &&
                      checkBoxChanges === rowForEdit?.isActive &&
                      (isMexicoChange === true) === (rowForEdit?.usedInMexico === true))
                  ) {
                    setChanges(true);
                  } else {
                    setChanges(false);
                  }

                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.jobCode &&
                  formMethods.formState.errors.jobCode.message &&
                  "border-2 border-red-500 col-span-2"
                }
                register={formMethods.register("jobCode", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="col-span-2 my-1">
              <CheckBoxLabelHookForm
                name="usedInMexico"
                type="checkbox"
                onClick={(e) => {
                  setIsMexicoChange(e.target.checked);

                  if (
                    ((e.target.checked === true) === (rowForEdit?.usedInMexico === true) &&
                      formMethods.getValues("employeeTitleName").trim() === rowForEdit?.employeeTitleName?.trim() &&
                      formMethods.getValues("jobLong").trim() === rowForEdit?.jobLong?.trim() &&
                      formMethods.getValues("jobCode").trim() === rowForEdit?.jobCode?.trim() &&
                      checkBoxChanges === rowForEdit?.isActive)
                  ) {
                    setChanges(true);
                  } else {
                    setChanges(false);
                  }
                }}
                register={register}
                label={
                  watch("usedInMexico")
                    ? "Uncheck if U.S."
                    : "Check if Mexico"
                }
                className="cursor-pointer auto-rows-auto text-right w-100 justify-items-center"
              />
            </div>
            <div className="col-span-2 my-1">
              <CheckBoxLabelHookForm
                name="isActive"
                type="checkbox"
                onClick={(e) => {
                  setCheckBoxChanges(e.target.checked);

                  if (
                    (e.target.checked === rowForEdit?.isActive &&
                      formMethods.getValues("employeeTitleName").trim() === rowForEdit?.employeeTitleName?.trim() &&
                      formMethods.getValues("jobLong").trim() === rowForEdit?.jobLong?.trim() &&
                      formMethods.getValues("jobCode").trim() === rowForEdit?.jobCode?.trim() &&
                      (isMexicoChange === true) === (rowForEdit?.usedInMexico === true))
                  ) {
                    setChanges(true);
                  } else {
                    setChanges(false);
                  }
                }}
                register={register}
                label={
                  watch("isActive")
                    ? "Uncheck to Deactivate"
                    : "Check to Activate"
                }
                className="cursor-pointer auto-rows-auto text-right w-100 justify-items-center"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeTitleDetails;
